// Mixin that resolves the active theme (light / dark / system) and applies
// a data-theme attribute on <html> so CSS can scope dark-mode overrides.

let mqListener = null

export default {
  computed: {
    themeMode: {
      get() {
        return this.$store.getters.uiThemeMode || 'light'
      },
      set(value) {
        this.$store.commit('uiThemeMode', value)
      },
    },

    themeModeOptions() {
      return [
        { value: 'light', text: 'Light' },
        { value: 'dark', text: 'Dark' },
        { value: 'system', text: 'System (auto)' },
      ]
    },

    resolvedTheme() {
      if (this.themeMode === 'system') {
        return this.systemPrefersDark ? 'dark' : 'light'
      }
      return this.themeMode
    },

    isDark() {
      return this.resolvedTheme === 'dark'
    },
  },

  data() {
    return {
      systemPrefersDark: window.matchMedia('(prefers-color-scheme: dark)').matches,
    }
  },

  watch: {
    resolvedTheme: {
      immediate: true,
      handler(theme) {
        document.documentElement.setAttribute('data-theme', theme)
        document.documentElement.classList.toggle('eden-dark', theme === 'dark')
      },
    },
  },

  created() {
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    mqListener = (e) => { this.systemPrefersDark = e.matches }
    mq.addEventListener('change', mqListener)
  },

  beforeDestroy() {
    if (mqListener) {
      const mq = window.matchMedia('(prefers-color-scheme: dark)')
      mq.removeEventListener('change', mqListener)
      mqListener = null
    }
  },
}
